module.exports = __webpack_public_path__ + "img/signupyyg.9feeca66.png";